const SwapIcon = () => (
  <svg
    width={14}
    height={11}
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.7041 7.44238H7.39844V8.17969H2.7041V9.9375L0.582031 7.81055L2.7041 5.68359V7.44238ZM12.6953 3.12402L10.5742 5.25098V3.49316H5.87988V2.75586H10.5742V0.99707L12.6953 3.12402Z"
      fill="white"
      stroke="white"
      strokeWidth={0.825066}
    />
  </svg>
);

export default SwapIcon;
